import React from 'react';

import { InstallApp } from '../install-app';

export const InstallAppPublic = () => <InstallApp isManualPage={true} />;
